import intersectPolygon from './intersect-polygon.module';

export default intersectPolygon;
